import { z } from 'zod';

export enum StandardAnalyticEventStatus {
  Active = 'Active',
  Deprecated = 'Deprecated',
}

export const StandardAnalyticEventSchema = z.object({
  id: z.uuid(),
  created: z.string().date(),
  updated: z.string().date(),
  name: z.string(),
  description: z.string(),
  categoryId: z.uuid(),
  customAttributeKeys: z.array(z.string()),
  status: z.enum(StandardAnalyticEventStatus),
  categoryName: z.string().optional(),
});

export type StandardAnalyticEvent = z.infer<typeof StandardAnalyticEventSchema>;

export interface StandardAnalyticEventFindAllParams {
  q?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  orderDirection?: 'asc' | 'desc';
  categoryId?: string;
  status?: StandardAnalyticEventStatus;
}
